<template>
  <div id="app">
    <v-app :style="spedimage" class="spedimage">
      <div>
        <sap-nav/>
      </div>
      <router-view/>
    </v-app>
  </div>
</template>

<script>

import sapNav from './components/SAP-Nav'
export default {
  components: {
    sapNav
  },
  data () {
    return {
    }
  },
  computed: {
    spedimage: function () {
      return {
        'background-image': 'url(' + this.$store.state.ttlinkoptics.spedImage + ')'
      }
    },
    maincolor: function () {
      return this.$store.state.ttlinkoptics.mainColor
    }
  }
}
</script>
<style>
  .spedimage {
    height: 100%;
    background-position: center !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    background-attachment: fixed !important;
  }
</style>
